import React from "react";

import "./SocialMediaLinks.scss";

interface SocialLink {
    href: string;
    iconClass: string;
    label: string;
    ariaLabel: string;
}

const socialLinks: SocialLink[] = [
    {
        href: "https://discord.gg/oberin",
        iconClass: "fab fa-discord",
        label: "Discord",
        ariaLabel: "Join the official Oberin Discord server",
    },
    {
        href: "https://www.facebook.com/oberinmmorpg?utm_source=oberin_website",
        iconClass: "fab fa-facebook",
        label: "Facebook",
        ariaLabel: "Visit the official Oberin Facebook page",
    },
    {
        href: "https://www.facebook.com/groups/OberinGroup/?utm_source=oberin_website",
        iconClass: "fab fa-facebook",
        label: "Facebook Community",
        ariaLabel: "Join the Oberin Facebook community group",
    },
    {
        href: "https://www.instagram.com/oberin_mmorpg?utm_source=oberin_website",
        iconClass: "fab fa-instagram",
        label: "Instagram",
        ariaLabel: "Follow Oberin on Instagram",
    },
    {
        href: "https://www.reddit.com/r/OberinMMORPG/?utm_source=oberin_website",
        iconClass: "fab fa-reddit-alien",
        label: "Reddit",
        ariaLabel: "Visit the Oberin subreddit",
    },
    {
        href: "https://www.youtube.com/@OberinMMORPG?utm_source=oberin_website",
        iconClass: "fab fa-youtube",
        label: "YouTube",
        ariaLabel: "Watch Oberin videos on YouTube",
    },
    {
        href: "https://www.tiktok.com/@oberinmmorpg?utm_source=oberin_website",
        iconClass: "fab fa-tiktok",
        label: "TikTok",
        ariaLabel: "Follow Oberin on TikTok",
    },
    {
        href: "https://x.com/oberin_mmorpg?utm_source=oberin_website",
        iconClass: "fab fa-twitter",
        label: "X / Twitter",
        ariaLabel: "Follow Oberin on X (Twitter)",
    },
    {
        href: "https://oberin.fandom.com/wiki/OberinWiki?utm_source=oberin_website",
        iconClass: "fas fa-book",
        label: "Oberin Wiki",
        ariaLabel: "Browse the Oberin Wiki",
    },
];

const SocialMediaLinks: React.FC = React.memo(function SocialMediaLinks() {
    return (
        <>
            {socialLinks.map((link) => (
                <a
                    key={link.href}
                    className="d-flex align-items-center clickable social-link"
                    href={link.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    aria-label={link.ariaLabel}
                >
                    <i
                        className={`${link.iconClass} social-icon`}
                        aria-hidden="true"
                    ></i>
                    <span className="ml-2">{link.label}</span>
                </a>
            ))}
        </>
    );
});

export default SocialMediaLinks;
